var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"somos-diferentes"},[_vm._m(0),_c('div',{staticClass:"button m-t-15",on:{"click":function($event){return _vm.scrollTo('#prices')}}},[_vm._v(" Nuestro servicio ")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('h3',[_vm._v(" Conoce lo que nos hace "),_c('strong',[_vm._v("UNICOS")])])
}]

export { render, staticRenderFns }